import Moment from "moment"
import { MONTHS_NAMES_ARRAY } from "../../helpers"

export const getPeriodMonthsRowCel = (sortedMinistrationsPlan, status) => {
  const periodColumns = {}

  sortedMinistrationsPlan.forEach(ministrationPlan => {
    const startMonthIndex = Moment(ministrationPlan?.ministrationStartDate).month()
    const startYear = Moment(ministrationPlan?.ministrationStartDate).year()
    const endMonthIndex = Moment(ministrationPlan?.ministrationEndDate).month()
    const endYear = Moment(ministrationPlan?.ministrationEndDate).year()
    const ministrationMonths = [
      `${MONTHS_NAMES_ARRAY[startMonthIndex]} ${startYear}`,
      `${MONTHS_NAMES_ARRAY[endMonthIndex]} ${endYear}`
    ]

    const startAndEndDatesAreEqual = startMonthIndex === endMonthIndex && startYear === endYear
    periodColumns[`period${ministrationPlan.orderIndex}`] = startAndEndDatesAreEqual
      ? `${MONTHS_NAMES_ARRAY[startMonthIndex]} ${startYear}`
      : ministrationMonths.join(" - ")
  })

  return { status, ...periodColumns }
}
